/* ═══════════════════════════════════════════════════════════════════════════
   flats-geo.js — фильтр «Метро и районы» витрины квартир города
   (/novostroyki/{город}/kvartiry/, 27.09.2026, слово владельца: «в фильтре витрины
   должен быть блок метро, как на странице Новостройки»).

   Зачем (человеческим языком). Окно выбора станций, районов и округов — ТО ЖЕ, что на
   «Новостройках» (js/geo-picker.js + app/templates/components/geo-picker-modal.php +
   css/geo-picker.css), здесь только «хозяин» для витрины квартир:
     • где лежит выбор и как он читается из адреса и пишется в запрос;
     • откуда окну взять список ЖК для чисел у строк (map_api.php?action=list, по
       нажатию — не при каждом открытии страницы);
     • что делать по «Показать»: сообщить js/flats.js событием `broni:flats-geo-change`,
       тот перезагружает выдачу во всех видах (сводка, плитка, список, планировки).

   Отбор квартир делает СЕРВЕР (flat_api.php → FlatHandler → CatalogGeoWhere::geoBuildingIds):
   квартира проходит, если её ЖК стоит у выбранной станции или в выбранном округе,
   районе, городе — то же правило, что у каталога ЖК.

   ⛔ ДЛЯ РОБОТА НИЧЕГО НОВОГО. Разметка окна приходит от сервера внутри
      <script type="text/html" id="nvGeoPickerTpl"> — это не текст страницы; в документ
      она вставляется ТОЛЬКО по нажатию на кнопку, станции рисуются при открытии.
   ⛔ Адрес с параметрами метро — служебный, как и прочие фильтры витрины: canonical
      страницы один, параметры склеены Clean-param в robots.txt (metro* — везде,
      okrug/district/place — на /novostroyki/).

   Пара: public/flats.php (подключение и шаблон), public/js/flats.js (состояние выдачи),
   public/js/flats-showcase.js (место кнопки в строке фильтра и планка телефона).
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  if (window.BroniFlatsGeo) return;

  const OFF = {
    params: () => [],
    reset: () => {},
    readUrl: () => {},
    setCity: () => {},
    active: () => false,
    summary: () => '',
  };

  const GP = window.BroniGeoPicker;
  const CF = window.CatalogFacets;
  const tpl = document.getElementById('nvGeoPickerTpl');
  const filters = document.getElementById('flatsFilters');
  // Витрина ОДНОГО ЖК — фильтр по месту там не нужен: дом уже назван адресом.
  const pinnedBuilding = String(window.BRONI_FLATS_BUILDING_ID || '');
  if (!GP || !CF || !tpl || !filters || pinnedBuilding) {
    window.BroniFlatsGeo = OFF;
    return;
  }

  let nets = {};
  try { nets = JSON.parse(tpl.getAttribute('data-geo-nets') || '{}') || {}; } catch (e) { nets = {}; }

  const q0 = new URLSearchParams(location.search);
  // Город — тем же порядком, что у flats.js (явный query → сервер → умолчание).
  let city = q0.get('city') || String(window.BRONI_FLATS_CITY || '') || 'krasnodar';
  let applied = GP.fromParams((name) => q0.get(name));
  let items = null;          // список ЖК города для чисел окна (map_api, профиль map)
  let itemsKey = '';
  let itemsReq = null;
  let withFlats = null;      // номера ЖК с квартирами в продаже (filter_options витрины)
  let optionsKey = '';
  let builtKey = '';
  let mounted = false;
  let built = false;
  let lastKey = '';

  const picker = GP.create({
    getApplied: () => applied,
    setApplied: (g) => { applied = g; },
    items: () => items || [],
    city: () => city,
    // Числа у строк — ЖК, в которых сейчас продаются квартиры (иначе окно обещало бы
    // «5 ЖК», а в выдаче квартир было бы из четырёх).
    base: () => (withFlats ? (it) => !!withFlats[String(it.id)] : null),
    refresh: () => changed(),
    onApply: () => changed(),
    emit: () => {},
    bodyLocked: () => document.body.classList.contains('zkv-sheet-lock'),
  });

  function paramsOf() {
    return GP.paramsOf(applied, picker._geo);
  }
  function keyOf() {
    return paramsOf().map((p) => p[0] + '=' + p[1]).join('&');
  }
  lastKey = keyOf();

  function size() {
    const d = CF.cloneDraft(applied);
    return CF.draftSize(d);
  }

  /* ── Кнопка в строке фильтра ─────────────────────────────────────────────
     Строится скриптом (в разметке для робота её нет) и ставится после цены:
     js/flats-showcase.js забирает группу #nvMetroTrigger в строку «город · ЖК ·
     комнатность · цена». id подписи и обёртки — те, что знает окно: число выбранного
     («Метро и районы · 2») и золотую подсветку ставит оно само. */
  const group = document.createElement('div');
  group.className = 'flats-filter-group zkv-geo';
  group.id = 'nvMetroTrigger';
  const lbl = document.createElement('span');
  lbl.className = 'flats-filter-label';
  // Подпись видна только в шторке телефона (в строке подписи групп спрятаны); слово
  // на кнопке и так «Метро и районы» — подпись не повторяет его.
  lbl.textContent = 'Расположение';
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'zkv-geo__btn';
  btn.id = 'flatsGeoBtn';
  btn.setAttribute('aria-haspopup', 'dialog');
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'nvMetroModal');
  btn.setAttribute('data-ym', 'flats_metro_open');
  const ico = document.createElement('i');
  ico.className = 'fas fa-train-subway';
  ico.setAttribute('aria-hidden', 'true');
  const txt = document.createElement('span');
  txt.id = 'nvMetroLabel';
  txt.className = 'zkv-geo__txt';
  const arr = document.createElement('i');
  arr.className = 'fas fa-chevron-down zkv-geo__arrow';
  arr.setAttribute('aria-hidden', 'true');
  btn.appendChild(ico);
  btn.appendChild(txt);
  btn.appendChild(arr);
  group.appendChild(lbl);
  group.appendChild(btn);

  const priceGroup = document.getElementById('priceMin');
  const priceBox = priceGroup ? priceGroup.closest('.flats-filter-group') : null;
  if (priceBox && priceBox.parentNode === filters) priceBox.insertAdjacentElement('afterend', group);
  else filters.appendChild(group);

  /** Подпись до того, как окно узнало витрину (оно ставит её само после build). */
  function paintLabel() {
    if (built) return;
    const n = size();
    txt.textContent = n > 0 ? 'Метро и районы · ' + n : 'Метро и районы';
    group.classList.toggle('is-active', n > 0);
  }

  /** Видна ли кнопка до списка ЖК: у города есть сеть метро — да; иначе решит build. */
  function paintVisible() {
    if (built) return;
    group.hidden = typeof nets[city] !== 'string';
  }

  function changed() {
    const key = keyOf();
    if (key === lastKey) return;
    lastKey = key;
    try {
      document.dispatchEvent(new CustomEvent('broni:flats-geo-change'));
    } catch (e) {
      // сообщать некому — выдача обновится при следующей смене фильтра
    }
  }

  /* ── Список ЖК для чисел окна — по первому нажатию ─────────────────────── */
  function scopeFromUrl() {
    // После явного «Сбросить» параметр исчезает; data-атрибут старого SSR тогда
    // использовать нельзя. «Назад» восстанавливает тот же параметр из адреса.
    return new URLSearchParams(location.search).get('landing_scope') || '';
  }
  function inventoryKey() { return city + '|' + scopeFromUrl(); }
  function loadItems() {
    const key = inventoryKey();
    if (items && itemsKey === key) return Promise.resolve(items);
    if (itemsReq && itemsKey === key) return itemsReq;
    const want = city;
    const scope = scopeFromUrl();
    itemsKey = key;
    items = null;
    if (optionsKey !== key) withFlats = null;
    const loadPage = (page) => {
      const query = new URLSearchParams({ action: 'list', city: want, limit: '1000', fields: 'map', page: String(page) });
      if (scope) query.set('landing_scope', scope);
      return fetch('/map_api.php?' + query, { credentials: 'same-origin' }).then((r) => {
        if (scope && !r.ok) throw new Error('Подборка ЖК временно недоступна');
        return r.json();
      });
    };
    itemsReq = loadPage(1)
      .then(async (data) => {
        if (key !== inventoryKey()) return null;
        if (!scope) {
          items = data && data.ok && Array.isArray(data.items) ? data.items : [];
          return items;
        }
        if (!data || !data.ok || !Array.isArray(data.items)) throw new Error('Подборка ЖК временно недоступна');
        const pages = Number(data.pages || 1);
        // Полный серверный состав, а не первые 1000 ЖК. Неверный или непомерный
        // ответ не маскируем частичным счётчиком в окне.
        if (!Number.isInteger(pages) || pages < 1 || pages > 10) throw new Error('Неполная подборка ЖК');
        const all = data.items.slice();
        for (let page = 2; page <= pages; page++) {
          const next = await loadPage(page);
          if (key !== inventoryKey()) return null;
          if (!next || !next.ok || !Array.isArray(next.items)) throw new Error('Неполная подборка ЖК');
          all.push(...next.items);
        }
        if (all.length !== Number(data.total)) throw new Error('Неполная подборка ЖК');
        items = all;
        return items;
      })
      .catch(() => {
        if (key === inventoryKey()) items = scope ? null : [];
        return scope ? null : items;
      })
      .finally(() => { if (key === inventoryKey()) itemsReq = null; });
    return itemsReq;
  }

  function buildNow() {
    if (!items) return;
    built = true;
    builtKey = itemsKey;
    picker.build(items);
    picker.hydrateFromState();
    // После build окно само решило, видна ли кнопка (сеть метро или районы из данных).
  }

  /** Разметка окна — в документ только по нажатию (см. шапку файла). */
  function mount() {
    if (mounted) return true;
    const holder = document.createElement('div');
    holder.innerHTML = tpl.textContent || '';
    const modal = holder.querySelector('#nvMetroModal');
    if (!modal) return false;
    document.body.appendChild(modal);
    mounted = true;
    picker.init();
    if (window.MutationObserver) {
      new MutationObserver(() => {
        btn.setAttribute('aria-expanded', modal.hasAttribute('hidden') ? 'false' : 'true');
      }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    }
    return true;
  }

  function open() {
    if (!mount()) return;
    // Окно открывается сразу (скелетон строк), числа и строки — когда придёт список ЖК.
    picker.open();
    loadItems().then((list) => {
      if (!list) return;
      if (!built || builtKey !== itemsKey) buildNow();
    });
  }

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    open();
  });

  // Номера ЖК с квартирами — их присылает flats.js после ответа filter_options.
  document.addEventListener('broni:flats-options', (e) => {
    const list = e && e.detail && Array.isArray(e.detail.buildings) ? e.detail.buildings : null;
    if (!list || e.detail.city !== city || (e.detail.landingScope || '') !== scopeFromUrl()) return;
    const set = {};
    list.forEach((b) => {
      if (b && b.id != null && (b.flat_count === undefined || +b.flat_count > 0)) set[String(b.id)] = 1;
    });
    withFlats = set;
    optionsKey = inventoryKey();
    if (built && picker.isOpen()) picker._recount();
  });

  paintLabel();
  paintVisible();

  window.BroniFlatsGeo = {
    /** Параметры запроса и адреса: [[имя, значение]]. */
    params: () => paramsOf(),
    /** «Сбросить» витрины: выбор снимается без своей перезагрузки (её делает flats.js). */
    reset: () => {
      applied = GP.emptyFilter();
      if (built) picker.reset(true);
      else { paintLabel(); }
      lastKey = keyOf();
    },
    /** «Назад»: выбор — из адреса. */
    readUrl: () => {
      const q = new URLSearchParams(location.search);
      applied = GP.fromParams((name) => q.get(name));
      if (built) picker.hydrateFromState();
      else paintLabel();
      lastKey = keyOf();
    },
    /** Смена города без перезагрузки: прежний выбор к новому городу не относится. */
    setCity: (slug) => {
      if (!slug || slug === city) return;
      city = slug;
      applied = GP.emptyFilter();
      items = null;
      withFlats = null;
      if (mounted && picker.isOpen()) picker.close();
      built = false;
      paintLabel();
      paintVisible();
      lastKey = keyOf();
    },
    /** Есть ли выбор (для «Сбросить» и планки телефона). */
    active: () => size() > 0,
    /** Короткая подпись для планки телефона: «Метро · 2». */
    summary: () => {
      const n = size();
      return n > 0 ? 'Метро · ' + n : '';
    },
  };
})();
